import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const cigarRollPricesApi = {
  // POST
  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cigarRollPrices`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  upload: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cigarRollPrices/upload`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // GET
  get: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarRollPrices`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default cigarRollPricesApi;
